import { Component } from 'react';
import { Button, Card, CardBody, CardGroup, Col, Container, Form, Row } from 'reactstrap';
import { connect } from 'react-redux';
import InputGroup from '../../../elements/Forms/InputGroup';
import * as actions from '../../../actions';
import { Field, reduxForm, InjectedFormProps } from 'redux-form';
import approve from 'approvejs';
import { getTranslationKey } from '../../../modules/utils/helpers';
import type { Notify } from '../../../typings/redux';
import type { RouteComponentProps } from 'react-router-dom';

interface FieldConfig {
  type: string;
  title: string;
  placeholder: string;
  rules: {
    required?: { message: string };
    equal?: {
      value: string;
      field: string;
      message: string;
    };
  };
}

interface FieldsConfig {
  password: FieldConfig;
  passwordConfirmation: FieldConfig;
}

const fields: FieldsConfig = {
  password: {
    type: 'password',
    title: getTranslationKey('newPassword'),
    placeholder: getTranslationKey('newPassword'),
    rules: {
      required: { message: getTranslationKey('requiredInput') }
    }
  },
  passwordConfirmation: {
    type: 'password',
    placeholder: getTranslationKey('passwordConfirm'),
    title: getTranslationKey('passwordConfirm'),
    rules: {
      required: { message: getTranslationKey('requiredInput') },
      equal: {
        value: '',
        field: 'password',
        message: getTranslationKey('passwordConfirmError')
      }
    }
  }
};

interface FormValues {
  password: string;
  passwordConfirmation: string;
}

interface OwnProps extends RouteComponentProps<{ type?: string }> {
  changeCurrentUserPassword: (password: string, notify: Notify) => void;
  notify: Notify;
}

type ChangePasswordProps = OwnProps & InjectedFormProps<FormValues, OwnProps>;

class ChangePassword extends Component<ChangePasswordProps> {
  constructor(props: ChangePasswordProps) {
    super(props);
    this.submit = this.submit.bind(this);
  }

  submit(values: FormValues): void {
    this.props.changeCurrentUserPassword(values.password, this.props.notify);
  }

  renderUserMessage(): string {
    switch (this.props.match.params.type) {
      case 'forgot':
        return getTranslationKey('forgotPasswordMessage');
      case 'change':
        return getTranslationKey('changePasswordMessage');
      case 'onboarding':
        return getTranslationKey('onboardingPasswordMessage');
      default:
        return getTranslationKey('changePasswordMessage');
    }
  }

  render(): JSX.Element {
    return (
      <div
        className="app flex-row align-items-center"
        style={{
          backgroundColor: 'gray',
          backgroundPosition: 'bottom'
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col md="10">
              <CardGroup className="primary-highlight-shadow">
                <Card className="p-4">
                  <CardBody>
                    <Form onSubmit={this.props.handleSubmit(this.submit)}>
                      <h1> {getTranslationKey('changePassword')}</h1>
                      <p className="text-muted">{this.renderUserMessage()}</p>
                      {Object.keys(fields).map((fieldKey, index) => (
                        <Field
                          component={InputGroup}
                          key={index}
                          name={fieldKey}
                          field={fields[fieldKey as keyof FieldsConfig]}
                        />
                      ))}
                      <Row>
                        <Col xs="12">
                          <Button
                            color="primary"
                            className="px-4 w-100-p"
                            disabled={
                              this.props.pristine || this.props.invalid || this.props.submitting
                            }
                            type="submit"
                          >
                            {getTranslationKey('changePassword')}
                          </Button>
                        </Col>
                        <Col xs="12">
                          {this.props.match.params.type === 'change' && (
                            <Button href="/#/account" color="link" className="px-0">
                              {getTranslationKey('back')}
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

function validate(values: FormValues): Partial<Record<keyof FormValues, any>> {
  const errors: any = {};

  fields.passwordConfirmation.rules.equal!.value = values.password;
  console.log(values);
  Object.keys(fields).forEach((fieldKey) => {
    const result = approve.value(
      values[fieldKey as keyof FormValues],
      fields[fieldKey as keyof FieldsConfig].rules
    );
    if (result.errors.length > 0) {
      errors[fieldKey] = result.errors;
    }
  });

  return errors;
}

interface RootState {
  notify: Notify;
}

const ChangePasswordForm = reduxForm<FormValues, OwnProps>({
  form: 'changePasswordForm',
  validate
})(ChangePassword);

export default connect(
  (state: RootState) => ({
    notify: state.notify
  }),
  actions
)(ChangePasswordForm);
